import { STATUS, TEXTS } from '@/views/PesosCocidos/cookedWeightsConstants'
import { formatKilogramText, formatMinimumWeight, formatWeight, kilogramTextToGrams } from '@/views/PesosCocidos/weightDisplay'
import { fillTemplate } from '@/views/PesosCocidos/textTemplate'
import { roundUpToPercent } from '@/views/PesosCocidos/weightYield'

const NO_GRAMS = 0

function hasValue (value) {
  return value !== null && value !== undefined
}

function hasRecipeYield (group) {
  return hasValue(group.reduction_percent) && Number(group.reduction_percent) > NO_GRAMS
}

function describeTitle (group) {
  const values = {
    weight: formatWeight(group.short_weight_grams),
    percent: roundUpToPercent(group.reduction_percent),
    minimum: formatMinimumWeight(group.theoretical_weight_grams)
  }
  return fillTemplate(hasRecipeYield(group) ? TEXTS.SHORT_ALERT_TITLE : TEXTS.SHORT_ALERT_TITLE_WITHOUT_YIELD, values)
}

function describeTakeFromStore (ingredient, rawGrams) {
  if (!hasValue(ingredient.gross_kg) || kilogramTextToGrams(ingredient.gross_kg) <= rawGrams) {
    return ''
  }
  return fillTemplate(TEXTS.TAKE_FROM_STORE, { gross: formatKilogramText(ingredient.gross_kg) })
}

export function describeCookLine (ingredient) {
  const rawGrams = kilogramTextToGrams(ingredient.raw_kg)
  if (rawGrams === NO_GRAMS) {
    return fillTemplate(TEXTS.COOK_LINE, { name: ingredient.ingredient_name, raw: TEXTS.LESS_THAN_ONE_GRAM })
  }
  const line = fillTemplate(TEXTS.COOK_LINE, { name: ingredient.ingredient_name, raw: formatKilogramText(ingredient.raw_kg) })
  return `${line}${describeTakeFromStore(ingredient, rawGrams)}`
}

export function buildShortWeightAlert (group) {
  if (group.status !== STATUS.SHORT_WEIGHED) {
    return null
  }
  const ingredients = group.ingredients_to_cook || []
  return {
    title: describeTitle(group),
    cookLines: ingredients.map((ingredient) => ({ key: ingredient.ingredient_id, text: describeCookLine(ingredient) }))
  }
}
